import { PipeTransform, Inject, Pipe } from "@angular/core";
import { FormatterService, FormatterServiceToken } from "../formatter/service/formatter.service";

@Pipe({
    name: "formatCard",
    pure: true
})
export class FormatCardNumberPipe implements PipeTransform {
    protected _formatterService: FormatterService;

    constructor(
        @Inject(FormatterServiceToken) formatterService: FormatterService
    ) {
        this._formatterService = formatterService;
    }

    transform(aNumber: string): string {
        return this._formatterService.formatCardNumber(aNumber);
    }
}
